import { connectorsForWallets, getDefaultConfig } from '@rainbow-me/rainbowkit'
import {
  binanceWallet,
  coinbaseWallet,
  injectedWallet,
  metaMaskWallet,
  okxWallet,
  phantomWallet,
  rabbyWallet,
  rainbowWallet,
  walletConnectWallet
} from '@rainbow-me/rainbowkit/wallets'
import { http } from 'viem'
import { mainnet, sepolia } from 'wagmi/chains'

import { isEnvProduction } from '../../util/app.helpers'

const isEnvProd = isEnvProduction() || true // @TODO Enforcing prod for now

const chains = [mainnet, sepolia]

const appConfig = {
  projectId: process.env.REACT_APP_WALLET_PROJECT_ID,
  appName: '$QBX claiming & staking',
  appDescription:
    'The most rewarding Web3 loyalty program. Claim and stake your QBX.',
  appUrl: 'https://claim.qiibeefoundation.org/',
  appIcon: 'https://vip.qiibeefoundation.org/assets/icons/qbx.png'
}

const PUBLIC_RPCS = {
  [mainnet.id]: [
    'https://ethereum.publicnode.com',
    'https://eth.merkle.io',
    'https://rpc.ankr.com/eth',
    'https://eth.llamarpc.com',
    'https://cloudflare-eth.com'
  ],
  [sepolia.id]: [
    'https://ethereum-sepolia.publicnode.com',
    'https://rpc.sepolia.org',
    'https://sepolia.drpc.org'
  ]
}

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Popular',
      wallets: [
        injectedWallet,
        metaMaskWallet,
        coinbaseWallet,
        rainbowWallet,
        walletConnectWallet,
        rabbyWallet,
        phantomWallet,
        okxWallet,
        binanceWallet
      ]
    }
  ],
  appConfig
)

const getWagmiConfig = getDefaultConfig({
  ...appConfig,
  connectors,
  chains,
  transports: {
    [mainnet.id]: http(PUBLIC_RPCS[mainnet.id][0]),
    [sepolia.id]: http(PUBLIC_RPCS[sepolia.id][0])
  },
  batch: {
    multicall: {
      batchSize: 1024 * 200, // Optimized for public RPCs
      wait: 16 // 16ms batching window
    }
  },
  ssr: false
})

const getChain = () => {
  return isEnvProd ? mainnet : sepolia
}

export { getChain, getWagmiConfig }
